module.exports = __webpack_public_path__ + "static/media/ktm-11.ec8bbc68.png";